export const sagaLoginActions = {
  AUTH_LOGIN_SAGA: "AUTH_LOGIN_SAGA"
};
